import React, { useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { ConfigFieldControl } from '@sierralabs/core-ui';
// import { useSendNewRoute } from '../hooks';
import { useCreateSiteDialog } from '../hooks/site-dialog/useCreateSiteDialog';
import { useSiteContext } from '../SiteContext';
import ComponentPicker from '../common/pickers/ComponentPicker';
const CreateDialogDialog = ({ open, onCancel, onCreated }) => {
    const [formValues, setFormValues] = useState({ type: 'dialog' });
    const { site } = useSiteContext();
    const { createdSiteDialog, createSiteDialog } = useCreateSiteDialog((site === null || site === void 0 ? void 0 : site.id) || '');
    const onCreatedRef = useRef(onCreated);
    useEffect(() => {
        var _a;
        if (createdSiteDialog) {
            // sendNewRoute(createdSiteDialog);
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdSiteDialog);
        }
    }, [createdSiteDialog]);
    return (React.createElement(Dialog, { fullWidth: true, open: open, onClose: onCancel },
        React.createElement(DialogTitle, null, "Create Dialog"),
        React.createElement("form", { onSubmit: event => {
                event.preventDefault();
                const { name, type } = formValues;
                if (name && type) {
                    createSiteDialog(name, type);
                }
            } },
            React.createElement(DialogContent, null,
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Dialog Name', value: formValues.name || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { name: event.target.value })) })),
                React.createElement(ConfigFieldControl, null,
                    React.createElement(ComponentPicker, { size: 'small', variant: 'outlined', label: 'Dialog Component Type', categories: ['dialog'], value: formValues.type, onTypeChange: type => {
                            setFormValues(Object.assign(Object.assign({}, formValues), { type }));
                        } }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onCancel }, "Cancel"),
                React.createElement(Button, { variant: 'contained', color: 'primary', type: 'submit', disabled: !formValues.name }, "Submit")))));
};
export default CreateDialogDialog;
//# sourceMappingURL=CreateDialogDialog.js.map